// 孕育周知
export default {
  weeklyDetail: '/newapi/router/weekly/detail', // 用户端-周刊详情页接口
  weeklyList: '/newapi/router/health-weeklylist/getWeeklyList', // 用户端--周刊模块列表数据
  shareDetail: '/newapi/router/weekly/sharedetail',  // 孕育周知免费领取权益页面内容数据
  getShareWeekly: '/newapi/router/health-weekly/getShareWeekly',  // 用户端--领取周知
  getWeeklyCombos: '/newapi/router/healthCombo/getWeeklyCombos', // 用户端-周刊套餐列表
  getWeeklyAudioUrl: '/newapi/router/health-zkaudio/getAudioUrl', // 周刊音视频获取
  updateMediaPlayLog: '/newapi/router/health-zkaudio/updateMediaPlayLog', // 周刊播放记录写入
  buyNow: '/newapi/router/cart/buyNow', // 用户端-周刊套餐购买下单
  submitorder: '/newapi/shopping/morder/submitorder', // 用户端-周刊套餐提交订单
  detail4payment: '/newapi/order/detail4payment', // 获取支付订单详情
  getPayWayList: '/newapi/pay/account/paywaylist', // 获取支付列表
  getSDKInfo: '/newapi/pay/account/getSDKInfo', // 用户端-获取唤起支付参数
  getCanBuyList: '/newapi/router/health-weeklylist/getCanBuyList', // 周刊主页-我的兑换可选周刊列表
  getWeeklyRight: '/newapi/router/health-wy-genWeekly/genWeeklyApi', // 周刊主页-领取免费周刊
  geIndexInfo: '/newapi/router/health-wy-home/homePage', // 周刊主页-主页接口
  sign: '/newapi/router/weekly/sign', // 用户签约
  confirmExchange: '/newapi/router/health-exchange/confirmExchange', // 周刊主页-确认兑换
  getItemMsg: '/newapi/router/health-exchange/getItemMsg', // 周刊主页-我的兑换 周刊简报
  prePayWayList: '/newapi/router/payment/prePayWayList'
};



// WEBPACK FOOTER //
// ./src/comm/api/knowing/index.js